import {
	logConstants,
	logConstantsType,
	TraceKind,
	AotCategoryType,
} from '../../utils/Constants';
import { AccountManager } from '../core/AccountManager';
import { NativeBridgeFactory } from '../bridge/nativeBridgeFactory';

export class Logger {
	private static instance: Logger;
	static getInstance(): Logger {
		if (!Logger.instance) {
			Logger.instance = new Logger();
		}
		return Logger.instance;
	}
	private config = AccountManager.Instance.configJSON;
	private nativeBridge = NativeBridgeFactory.getBridge();
	private module = 'AccountConfig';
	/// <summary>
	/// writes a trace message to native file
	/// </summary>
	/// <param name="level">log level (Message/Error/Debug)</param>
	/// <param name="message">log message string</param>
	/// <param name="aotCategory">AOT category (Error/Info/Warning/Failure)</param>
	/// <param name="aoTrace">AOT trace string. If undefined, "message" parameter is logged</param>
	write(
		level: logConstantsType,
		message: string,
		aotCategory?: AotCategoryType,
		aoTrace?: string
	): void {
		switch (level) {
			case logConstants.INFO:
				console.info(`${this.module} : ${message}`);
				if (this.config.nativeLoggingEnabled == true) {
					this.nativeBridge.writeTrace(this.module, message, TraceKind.Message);
				}
				break;
			case logConstants.ERROR:
				console.error(`${this.module} : ${message}`);
				if (this.config.nativeLoggingEnabled == true) {
					this.nativeBridge.writeTrace(this.module, message, TraceKind.Error);
				}
				break;
			case logConstants.DEBUG:
				console.debug(`${this.module} : ${message}`);
				if (this.config.nativeLoggingEnabled == true) {
					this.nativeBridge.writeTrace(this.module, message, TraceKind.Debug);
				}
				break;
			default:
				console.log(`${this.module} : ${message}`);
				if (this.config.nativeLoggingEnabled == true) {
					this.nativeBridge.writeTrace(this.module, message, TraceKind.Message);
				}
				break;
		}

		if (aotCategory) {
			this.writeAot(aotCategory, aoTrace ?? message);
		}
	}

	/// <summary>
	/// writes an always-on trace message to native file
	/// </summary>
	/// <param name="category">log category (Error/Info/Fatal/Warning)</param>
	/// <param name="trace">log string</param>
	writeAot(category: AotCategoryType, trace: string): void {
		if (this.config.nativeLoggingEnabled == true) {
			this.nativeBridge.writeTrace(this.module, trace, null, category);
		}
	}

	/**
	 * Logs an error message.
	 * @param message - The error message to log.
	 * @param aotCategory - Optional. The category of the error.
	 * @param aoTrace - Optional. The trace of the error.
	 */
	logError(message: string, aotCategory?: AotCategoryType, aoTrace?: string): void {
		this.write(logConstants.ERROR, message, aotCategory, aoTrace);
	}

	/**
	 * Logs an informational message.
	 * @param message - The message to be logged.
	 * @param aotCategory - The category of the message (optional).
	 * @param aoTrace - The trace information (optional).
	 */
	logInfo(message: string, aotCategory?: AotCategoryType, aoTrace?: string): void {
		this.write(logConstants.INFO, message, aotCategory, aoTrace);
	}

	/**
	 * Logs a debug message.
	 * @param message - The debug message to log.
	 * @param aotCategory - Optional. The AOT category.
	 * @param aoTrace - Optional. The AO trace.
	 */
	logDebug(message: string, aotCategory?: AotCategoryType, aoTrace?: string): void {
		this.write(logConstants.DEBUG, message, aotCategory, aoTrace);
	}
}
